import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams, PaginatedResponse } from 'services/api/types'
import { OrderPriceListProducts } from 'modules/orders/types'

const loadOrderFreights = (
  data: PaginatedParams
): PaginatedResponse<OrderPriceListProducts> => {
  const { page = 1, limit = 10 } = data
  return axios.get(`/orders/freight-type`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadOrderFreights(params: PaginatedParams) {
  return useQuery(['orderFreights'], () => loadOrderFreights(params), {
    onError: () =>
      toast.error('Não foi possível carregar fretes!', {
        toastId: 'loadOrderFreights'
      })
  })
}
